// Expiry is optional, if not set then cookie stays active till year 2035
import { FEATURES, MODULES } from '../constants/template-info'

import getCookieDomain from './getCookieDomain'
import isBrowser from './isBrowser'
import { captureException } from './sentryUtil'

const setCookie = (
  name: string,
  value: string | undefined | boolean,
  expiryMinutes: number | undefined = undefined,
  isSecure: boolean | undefined = false,
) => {
  if (!isBrowser()) return
  try {
    let expires = ''
    if (!expiryMinutes) {
      expires = 'Fri, 18 May 2035 12:00:00 UTC'
    }
    if (expiryMinutes) {
      const date = new Date()
      date.setTime(date.getTime() + expiryMinutes * 60 * 1000)
      expires = date.toUTCString()
    }
    let cookie = `${name}=${value}; expires=${expires}; path=/; domain=${getCookieDomain()}`
    if (isSecure) {
      cookie += '; Secure'
    }
    document.cookie = cookie
  } catch (error) {
    captureException('setCookie error', {
      module: MODULES.COOKIE_STORAGE,
      feature: FEATURES.SET_COOKIE,
      extraInfo: {
        capturedFrom: 'set cookie function',
        cookieKey: name,
        cookieValue: value,
        errorDetail: JSON.stringify(error),
      },
    })
  }
}

export default setCookie
